

import {instance} from '@/Utils/axios'

export default {
  getList: params => instance.get('/nhf-fine/exportmanagement/page', {params}),
};